export default class INGSSOValuesProvider {
    getFlowDisplayName = () => {
        return 'ING single-sign-on flow';
    }

    getRedirectionDetails = () => {
        return {
            baseUrlForClient: '/b-auth-policy-search',
            state: { policyNumberEditable: true }
        };
    }

    isBrokerContext = () => {
        return false;
    }

    getTypefilterNameForReporterRelation = () => {
        return 'FrontEndSelectable';
    }

    saveAndResumeEnabled = () => {
        return true;
    }

    getAuthenticationChannel = () => {
        return 'B2C';
    };
}
